<template>
  <div class="content">
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.name"
          :label="$t('forms.labels.name')"
          :rules="{ required: true }"
          hideDetails
          data-cy="controllerName"
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>

    <!-- Sera utilisé plus tard - Maquette a revoir -->
    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.make"
          :items="makes"
          :label="$t('forms.labels.make')"
          :rules="{ required: true }"
          hideDetails
          outlined
          data-cy="flowMeterForm-make"
          @input="updateData"
        />
      </v-col>
    </v-row>

    <!-- Sera utilisé plus tard - Maquette a revoir -->
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.model"
          :label="$t('forms.labels.model')"
          :rules="{ required: true }"
          hideDetails
          outlined
          data-cy="flowMeterForm-model"
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.controllerId"
          :label="$t('forms.labels.id')"
          :rules="{ required: true }"
          hideDetails
          required
          data-cy="controllerId"
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.connectionType"
          required
          itemValue="key"
          :label="$t('devices.connectionType')"
          :items="devicesList"
          cacheItems
          outlined
          deletableChips
          hideDetails
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.dateFormat"
          required
          :items="dateFormat"
          :label="$t('forms.labels.dateFormat')"
          hideDetails
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { AQ_GATEWAY, CONNECTION_TYPES } from '@/aquassist-shared/constants/types/deviceConnection';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import deviceHubMake from '@/constants/deviceHubMake';
import { controllerDateFormats } from '@/aquassist-shared/constants/formats';

export default {
    name: 'ControllerForm',
    components: {
        VTextField,
        VSelect,

    },
    props: {
        controller: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            data: {
                name: '',
                controllerId: '',
                make: '',
                model: '',
                idNumber: '',
                connectionType: AQ_GATEWAY,
                dateFormat: '',
            },
            makes: deviceHubMake,
        };
    },
    computed: {
        ...mapGetters([
            'selectedSite',
            'teamID',
        ]),
        devicesList() {
            return CONNECTION_TYPES.map(item => ({
                key: item,
                name: this.$t(`devices.controllersHubs.connectionType.${item}`),
            }));
        },
        dateFormat() {
            return controllerDateFormats;
        },
    },
    created() {
        if (this.controller) {
            // if this.controller is true, we are editing an existing controller
            this.data = { ...this.data, ...cloneDeep(this.controller) };
        }
    },

    methods: {

        updateData() {
            this.$emit('sendData', this.data);
        },
        addNewProb() {
            this.data.probes.push(this.emptyProbe());
        },
        removeProbe(probeId) {
            if (this.data.probes.length > 1) {
                this.data.probes = this.data.probes.filter(probe => probe.probeId !== probeId);
            }
        },
        emptyProbe() {
            return {
                name: '',
                probeId: '',
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    padding-top: 0px;
}
.text {
    font-size: 18px;
}
.content {
    padding: 0 10%;
    min-width: 300px
}
.probe-title {
    margin-bottom: 0;
    margin-top: 16px;
    font-size: 16px;
    font-weight: 500;
}
.number {
    margin: 0 4% 0 5px;
    background: #26384b;
    border-radius: 50%;
    color: white;
    height: 18px;
    width: 18px;
    text-align: center;
    font-size: 11px;
    line-height: 20px;
}
</style>
